import { createFileRoute } from '@tanstack/react-router';
import { JourneysNewsletterSetupHandoff } from '@/pages/workspaces/broadcasts/newsletter/setup/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/setup',
)({
  component: JourneysNewsletterSetupHandoff,
});
